import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import config from "@/config";
const title = config.title;

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/live"
    },
    //直播官网
    {
      path: "/live",
      name: "PageView",
      component: resolve => require(["@/view/Live/IndexView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/index"
        },
        {
          path: "/index",
          name: "index",
          component: resolve => require(["@/view/Live/home/home"], resolve),
          meta: {
            title: title + " - 直播"
          }
        },
        {
          path: "/video",
          name: "video",
          component: resolve => require(["@/view/Live/video/video"], resolve),
          meta: {
            title: title + " - 视频"
          }
        },
        {
          path: "/stream",
          name: "stream",
          component: resolve => require(["@/view/Live/stream/stream"], resolve),
          meta: {
            title: title + " - 直播"
          }
        },
        {
          path: "/article",
          name: "article",
          component: resolve => require(["@/view/Live/agreement/article"], resolve),
          meta: {
            title: title
          }
        },
        {
          path: "/agreement",
          name: "agreement",
          component: resolve => require(["@/view/Live/agreement/agreement"], resolve),
          meta: {
            title: title
          }
        },
        {
          path: "/user",
          name: "user",
          component: resolve => require(["@/view/Live/user/index"], resolve),
          meta: {
            title: title + " - 个人中心"
          },
          children: [
            {
              path: "/",
              redirect: "/user/userInfo"
            },
            {
              path: "/user/userInfo",
              name: "userInfo",
              component: resolve => require(["@/view/Live/user/userInfo/userInfo.vue"], resolve),
              meta: {
                title: title + " - 个人信息"
              }
            },
            {
              path: "/user/payLog",
              name: "payLog",
              component: resolve => require(["@/view/Live/user/payLog/payLog.vue"], resolve),
              meta: {
                title: title + " - 充值记录"
              }
            }
          ]
        }
      ]
    },
    /*
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: title + "-首页"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: title + "-软件产品"
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown"
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: resolve =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "软件产品丨Tessai资管后台"
              }
            },
            {
              path: "/software/bigData",
              name: "software",
              component: resolve =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "软件产品丨Tessai资管客户端"
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: title + "-相关服务"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: title + "-新闻动态"
          }
        },
        {
          path: "/newsinformationdetail",
          name: "newsinformationdetail",
          component: resolve =>
            require(["@/view/NewsInformationDetail"], resolve),
          meta: {
            title: title + "-新闻详情"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: title + "-公司介绍"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: title + "-工作机会"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: title + "-联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: title + "-相关服务"
          }
        }
      ]
    }
    */
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js